module.exports = __webpack_public_path__ + "media/img/slider2-063496fa708d547353b0c185b091b9f1.png";